import React, { memo } from 'react';
import { formats } from 'investira.sdk';
import { HighchartsReact } from 'investira.react.charts';

const LEGEND_MAX_HEIGHT = 100;
const LEGEND_LABEL_WIDTH = 220;
const THRESHOLD_PERCENT = 0.01;
const OTHERS_LABEL = 'Outros';

const EmissoresChart = memo(props => {
  const { data = [] } = props;

  const processData = pData => {
    const xTotal = pData.reduce((sum, item) => sum + item.financeiro, 0);
    const xThreshold = xTotal * THRESHOLD_PERCENT;

    const xMainData = [];

    let xOthersSumFinanceiro = 0;
    let xOthersSumAtivos = 0;

    pData.forEach(item => {
      if (item.financeiro >= xThreshold) {
        xMainData.push({
          name: item.pessoa_fantasia,
          y: item.financeiro,
          showInLegend: true,
          metadata: {
            ...item,
            percentual: xTotal
              ? `${formats.formatNumber((item.financeiro / xTotal) * 100, 2, true)}%`
              : '--%',
            reference_total: xTotal,
            financeiro: formats.formatNumber(item.financeiro, 2, true, true)
          }
        });
      } else {
        xOthersSumFinanceiro += item.financeiro;
        xOthersSumAtivos += item.quantidade_ativos;
      }
    });

    if (xOthersSumFinanceiro > 0) {
      xMainData.push({
        name: OTHERS_LABEL,
        y: xOthersSumFinanceiro,
        showInLegend: true,
        metadata: {
          percentual: xTotal
            ? `${formats.formatNumber((xOthersSumFinanceiro / xTotal) * 100, 2, true)}%`
            : '--%',
          reference_total: xTotal,
          financeiro: formats.formatNumber(xOthersSumFinanceiro, 2, true, true),
          quantidade_ativos: xOthersSumAtivos
        }
      });
    }

    return xMainData.sort((xItemA, xItemB) => {
      if (xItemA.name === OTHERS_LABEL) {
        return 1;
      }
      if (xItemB.name === OTHERS_LABEL) {
        return -1;
      }

      return xItemB.y - xItemA.y;
    });
  };

  const xOptions = {
    chart: {
      type: 'pie',
      height: '340px'
    },
    title: false,
    legend: {
      align: 'center',
      enabled: true,
      labelFormatter: function () {
        const xSeriesData = Array.isArray(this.series?.options?.data)
          ? this.series.options.data
          : [];
        const xSeriesTotal = xSeriesData.reduce((xSum, xPoint) => xSum + (xPoint?.y || 0), 0);
        const xTotal =
          xSeriesTotal ||
          this.series?.userOptions?.reference_total ||
          this.options?.metadata?.reference_total ||
          this.metadata?.reference_total ||
          0;
        const xPercentual = xTotal ? formats.formatNumber((this.y / xTotal) * 100, 2, true) : '--';
        const xDecoration = this.visible !== false ? 'none' : 'line-through';

        return `<span style="display: inline-flex; align-items: center; justify-content: space-between; gap: 8px; width: ${LEGEND_LABEL_WIDTH}px;">
          <span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; text-decoration: ${xDecoration};">${this.name}</span>
          <span style="flex-shrink: 0; text-align: right; text-decoration: ${xDecoration};">${xPercentual}%</span>
        </span>`;
      },
      itemMarginBottom: 6,
      layout: 'vertical',
      maxHeight: LEGEND_MAX_HEIGHT,
      navigation: {
        activeColor: '#00dfa8',
        inactiveColor: '#7a81ab',
        style: {
          color: '#FFFFFF'
        }
      },
      useHTML: true,
      verticalAlign: 'bottom'
    },
    plotOptions: {
      pie: {
        innerSize: '50%',
        borderColor: '#2e2e46', // Cor do contorno (borda)
        borderWidth: 2, // Largura do contorno
        shadow: false,
        dataLabels: {
          enabled: false,
          style: {
            color: '#FFFFFF',
            textOutline: 'none',
            zIndex: 1
          }
        }
      }
    },
    tooltip: {
      useHTML: true,
      style: {
        zIndex: 1000 // Set a high z-index for the tooltip
      },
      pointFormat: `Financeiro: <b>{point.metadata.financeiro}</b><br>Quantidade de Ativos: <b>{point.metadata.quantidade_ativos}</b><br>Percentual: <b>{point.metadata.percentual}</b>`
    },
    series: [
      {
        name: 'Emissor',
        colorByPoint: true,
        data: processData(data),
        showInLegend: true
      }
    ]
  };

  return <HighchartsReact options={xOptions} />;
});

export default EmissoresChart;
